var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.75C12.375 0.75 0.75 12.375 0.75 27C0.75 41.625 12.375 53.25 27 53.25C41.625 53.25 53.25 41.625 53.25 27C53.25 12.375 41.625 0.75 27 0.75ZM37.125 40.125L27 30L16.875 40.125L13.875 37.125L24 27L13.875 16.875L16.875 13.875L27 24L37.125 13.875L40.125 16.875L30 27L40.125 37.125L37.125 40.125Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/redCross.cdf483118173e4c5042eee07a13b4ba3.svg";
export { ForwardRef as ReactComponent };